import { render, staticRenderFns } from "./RelatorioMovimento.vue?vue&type=template&id=11791fab&"
import script from "./RelatorioMovimento.vue?vue&type=script&lang=js&"
export * from "./RelatorioMovimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports